import React, { Component } from "react";
import "./style.css";

export default class MinistrySteps extends Component {
  render() {
    const { data, activeStep } = this.props;
    console.log(data);
    return (
      <div className="hr-steps">
        <div className="rc-steps rc-steps-horizontal rc-steps-label-horizontal ">
          <div
            className={
              activeStep === 1 || activeStep === 0
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait col-3"
            }
            style={{ display: "flex" }}
          >
            <div className="rc-steps-item-container">
              <div className="rc-steps-item-tail" />
              <div className="rc-steps-item-icon ">
                <span className="rc-steps-icon">1</span>
              </div>
              <div className="rc-steps-item-content">
                <div className="rc-steps-item-title">
                  मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट प्रारम्भिक नतिजा
                  तयार
                  <br />(
                  {data && data.status_in_review_date
                    ? data.status_in_review_date
                    : "-"}
                  )
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              activeStep === 2
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait  col-3"
            }
            style={{ display: "flex" }}
          >
            <div className="rc-steps-item-tail" />
            <div className="rc-steps-item-icon">
              <span className="rc-steps-icon">2</span>
            </div>
            <div className="rc-steps-item-content">
              <div className="rc-steps-item-title">
                मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट मुल्यांकनको लागि
                पेश
                <br />(
                {data && data.status_reviewed_date
                  ? data.status_reviewed_date
                  : "-"}
                )
              </div>
            </div>
          </div>
          <div
            className={
              activeStep === 3
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait  col-3"
            }
            style={{ display: "flex" }}
          >
            <div className="rc-steps-item-container">
              <div className="rc-steps-item-tail" />
              <div className="rc-steps-item-icon">
                <span className="rc-steps-icon">3</span>
              </div>
              <div className="rc-steps-item-content">
                <div className="rc-steps-item-title">
                  समीक्षक बाट पृष्ठपोषण सम्पन्न
                  <br />(
                  {data && data.status_approved_date
                    ? data.status_approved_date
                    : "-"}
                  )
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              activeStep === 4
                ? "rc-steps-item rc-steps-item-process rc-steps-item-active col-3"
                : "rc-steps-item rc-steps-item-wait  col-3"
            }
            style={{ display: "flex" }}
          >
            {activeStep >= 4 ? (
              <>
                <div className="rc-steps-item-tail" />
                <div className="rc-steps-item-icon">
                  <span className="rc-steps-icon">4</span>
                </div>
                <div className="rc-steps-item-content">
                  <div className="rc-steps-item-title">
                    समीक्षाहेरी मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट
                    सार्वजनिक
                    <br />(
                    {data && data.status_published_date
                      ? data.status_published_date
                      : "-"}
                    )
                  </div>
                </div>
              </>
            ) : (
              <div
                className="rc-steps-item-container"
                style={{ display: "flex" }}
              >
                <div className="rc-steps-item-tail" />
                <div className="rc-steps-item-icon">
                  <span className="rc-steps-icon">4</span>
                </div>
                <div className="rc-steps-item-content">
                  <div className="rc-steps-item-title">
                    समीक्षाहेरी मुख्यमन्त्री तथा मन्त्रिपरिषद्को कार्यालयबाट
                    सार्वजनिक <br />(
                    {data && data.status_published_date
                      ? data.status_published_date
                      : "-"}
                    )
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
